<template>
  <Card class="library-card dummy-card">
    <div class="card-cover-img-thumb"></div>
    <div class="card-block">
      <div class="row">
        <div class="col-12 card-info-section">
          <h4 class="card-title typography--title"></h4>
          <small class="typography--caption"></small>
          <div class="card-bottom-desc">
            <div>
              <small class="typography--caption typography--color-secondary"></small>
            </div>
            <div>
              <small class="typography--caption typography--color-secondary"></small>
            </div>
            <div>
              <small class="typography--caption typography--color-secondary"></small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-action"></div>
  </Card>
</template>

<script>
  export default {
    name: 'library-card',
  };
</script>

<style lang="scss">
  .dummy-card {
    .card-info-section>.typography--title {
      margin-bottom: 12px;
      width: 180px;
      max-width: 100%;
      height: 24px;
      background-color: #f2f2f2;
    }

    .card-info-section>.typography--caption {
      width: 140px;
      max-width: 100%;
      height: 12px;
      background-color: #f7f7f7;
    }

    .card-bottom-desc .typography--caption {
      margin-top: 8px;
      width: 116px;
      max-width: 100%;
      height: 12px;
      background-color: #f7f7f7;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DummyCard.vue